import { ConnectionNames } from "../Contracts";
import { QueryBuilder } from "./Helpers";
import { BaseRESTConnection } from "../Common";
export class PlayerDataConnection extends BaseRESTConnection {
    constructor(meta) {
        super(ConnectionNames.player, meta);
    }
    getLimitsHistory(params) {
        return this.applyQuery(QueryBuilder.getLimitsHistory(params));
    }
    getPlayer() {
        return this.applyQuery(QueryBuilder.getPlayer());
    }
}
//# sourceMappingURL=PlayerDataConnection.js.map